export enum ClusterKey {
  CLUSTERS_ENABLE = 'clusters_enable',
}

export enum M20Key {
  MAX_LICENSE = 'maxlicense',
}
